// 서명 제목 글자수 제한. 최대 50글자(byte 아님)까지 허용하고, 초과 시 잘라낸다.
// 코드포인트 기준으로 세고 자르므로(이모지 등 서로게이트 페어를 쪼개지 않음),
// Input maxLength(UTF-16 코드유닛)로 막힌 사용자 입력뿐 아니라 자동 생성/백엔드 로딩 값에도
// 항상 "글자수 50 이하"가 보장된다.
export const SIGNATURE_TITLE_MAX_LENGTH = 50

interface TruncateResult {
  title: string
  truncated: boolean
}

export function truncateSignatureTitle(title: string): TruncateResult {
  const codePoints = Array.from(title)
  if (codePoints.length <= SIGNATURE_TITLE_MAX_LENGTH) {
    return { title, truncated: false }
  }

  return {
    title: codePoints.slice(0, SIGNATURE_TITLE_MAX_LENGTH).join(''),
    truncated: true,
  }
}
